import FullSite from "./full-site";
import { PrintOddsTemplate } from "../../jamibet/desktop-pages/print-odds";

export default function PrintOdds() {
	return <FullSite><PrintOddsTemplate /></FullSite>;
}
